import { getOnlyNumbers } from '@/utils';
import api from '..';
import { RequestSMSSending, RequestSMSConfirmation } from './types';

export const requestSMSSending = ({ saleID, msisdn }: RequestSMSSending) => {
  return api.post(`/core/sms-confirmacao/enviar-sms`, {
    venda_id: saleID,
    msisdn: getOnlyNumbers(msisdn),
  });
};

export const requestSMSConfirmation = ({
  saleID,
  msisdn,
  sms,
}: RequestSMSConfirmation) => {
  return api.post(`/core/sms-confirmacao/confirmar-recebimento`, {
    venda_id: saleID,
    token_sms: sms,
    msisdn: getOnlyNumbers(msisdn),
  });
};
